import React from 'react';

import styles from './styles.module.scss';

import { ListOnRoveLandingType } from '@utils/types/landings';
import {
  LandingCheckmark,
  BackgroundChecks,
  Insurance,
  SecurityDeposit,
} from '@assets/icons';
import WysiwygText from '@components/_shared/wysiwygText';

const ListOnRoveClientele = (props: ListOnRoveLandingType['clientele']) => {
  const { title, description, items } = props;

  const icon = (index: number) => {
    switch (index) {
      case 0:
        return <BackgroundChecks />;
      case 1:
        return <SecurityDeposit />;
      case 2:
        return <Insurance />;
      default:
        return <LandingCheckmark />;
    }
  };

  return (
    <div className={styles.clientele}>
      <div className={styles.clientele__wrapper}>
        <h4 className={styles.clientele__title}>{title}</h4>
        <div className={styles.clientele__description}>{description}</div>

        <div className={styles.clientele__items}>
          {items?.map((i, index) => (
            <div className={styles.item} key={i._key}>
              <div className={styles.item__title}>
                {icon(index)}
                {i.title}
              </div>
              <div className={styles.item__description}>
                {typeof i.description === 'string' ? (
                  i.description
                ) : (
                  <WysiwygText content={i.description} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListOnRoveClientele;
